import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
export interface WidgetActionEvent {
  sourceWidgetId: string;
  actionId: string;
  payload?: any;
}
@Injectable({
  providedIn: 'root'
})
export class WidgetActionService {
  private actionSubject = new Subject<WidgetActionEvent>();
  action$ = this.actionSubject.asObservable();

  emit(event: WidgetActionEvent) {
    this.actionSubject.next(event);
  }
}
